<template>
  <main id="about-page">
    <ContentTitle
      :category="$t('sideMenu.Firmware')"
      :categoryIcon="'scf-traced'"
      :title="$t('sideMenu.CompaignDetail')"
    /><br />

    <div style="max-width: 100%">
      <div class="row">
        <div class="ml-15" style="width: 100%; float: left">
          <card
            :title="compaign.externalId"
            :styles="'overflow-none'"
            :fullScreen="false"
            :icon="{ class: 'scf-maintenance', styles: 'padding:5px;' }"
            :enableCollapse="false"
          >
            <template v-slot:card-drop-down> </template>

            <template v-slot:card-body-title> </template>

            <template v-slot:card-body-container>
              <div class="row" style="padding-left: 25px">
                <div class="row" style="padding-top: 10px">
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.Description") }}:
                    </div>
                    {{ compaign.description }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.EndDate") }}:
                    </div>
                    {{ format_date(compaign.campaingEndDate) }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.TargetFirmwareVersion") }}:
                    </div>
                    {{ compaign.firmwareversion }}
                  </div>
                </div>

                <div class="row" style="padding-top: 10px">
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.Manufacturer") }}:
                    </div>
                    {{ compaign.manufacturerExternalId }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.Status") }}:
                      <ToolTip :title="'Tooltip'" :content="TooltipContent">
                        <div class="scf-help icon"></div>
                      </ToolTip>
                      <!-- <div class="tooltip">
                <img src="../assets/icons/help.png" class="icon" />
                <span class="tooltiptext">
                  <span class="title-tooltip">
                    {{
                      getTraductionStateCompaign(compaign.statusEnum)
                    }}: </span
                  ><br />
                  {{
                    $t(
                      "pages.CompaignList.StateDescription." +
                        compaign.statusEnum
                    )
                  }}
                </span>
              </div> -->
                    </div>
                    {{ getTraductionStateCompaign(compaign.statusEnum) }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.DownlinkChannelEnum") }}:
                    </div>
                    {{ compaign.downlinkChannelEnum }}
                  </div>
                </div>
                <div class="row" style="padding-top: 10px">
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.DownlinkModulationEnum") }}:
                    </div>
                    {{ compaign.downlinkModulationEnum }}
                  </div>
                  <div class="col-4">
                    <div class="ElementBox">
                      {{ $t("pages.CompaignDetail.CreatedDate") }}:
                    </div>
                    {{ format_date(compaign.createdDate) }}
                  </div>
                  <div class="col-4"></div>
                </div>
              </div>
            </template>
            <template v-slot:card-footer>
              <div id="myDiv" class="tooltip1">
                <!-- <ToolTip :title="'Tooltip'" :content="TooltipContentProgressBar"
              > </ToolTip><div> </div> -->
                <progressBarRange
                  :Globalfail="Globalfail"
                  :key="componentKey"
                  :Successful="StateCount.Successful"
                  :InProgress="StateCount.InProgress"
                  :Failed="StateCount.Failed"
                  :Pending="StateCount.Pending"
                  :Planned="StateCount.Planned"
                ></progressBarRange>

                <span class="tooltiptext1">
                  <span class="title-tooltip1">
                    {{ $t("pages.CompaignDetail.Status") }} </span
                  ><br />
                  <span class="badge rounded-pill bg-successful"
                    >{{ StateCount.Successful }}
                  </span>
                  {{ $t("pages.CompaignDetail.State.Successful") }}<br />
                  <span class="badge rounded-pill bg-inProgress">{{
                    StateCount.InProgress
                  }}</span>
                  {{ $t("pages.CompaignDetail.State.InProgress") }}<br />
                  <span class="badge rounded-pill bg-failed">{{
                    StateCount.Failed
                  }}</span>
                  {{ $t("pages.CompaignDetail.State.Failed") }}<br />
                  <span class="badge rounded-pill bg-pending">{{
                    StateCount.Pending
                  }}</span>
                  {{ $t("pages.CompaignDetail.State.Pending") }}<br />
                  <span class="badge rounded-pill bg-planned">{{
                    StateCount.Planned
                  }}</span>
                  {{ $t("pages.CompaignDetail.State.Planned") }}<br />
                </span>
              </div>
            </template>
          </card>
        </div>
      </div>
      <br />
      <div class="row">
        <div style="flex: auto" v-if="gridComponentKey > 0">
          <!-- group panel -->
          <OdataFlexGrid
            :key="gridComponentKey"
            v-if="compaign.id"
            :Api="{
              base: urlOdata + 'api/v1/OData/',
              controller:
                'firmwareCampaignTransmitters?firmwareCampaignId=' +
                compaign.id,
            }"
            :requestHeaders="gridHeaders"
            :FiltersDefinition="FiltersDefinition"
            :ColumnsDefinition="columns"
            :allowPinning="'SingleColumn'"
            :FilterColumns="[
              'HardwareVersion',
              'UpdatedDate',

              'StatusEnum',
              'FailureErrorDetail',
            ]"
            :displayLang="culture"
            v-on:initializedGrid="gridInitialized"
            v-on:gridFilterChanged="gridFilterChanged"
            :GridId="'firmwareList2'"
            :ExportsButtons="{
              Header: ExportsHeader,
              DataSource: ExportsDataSource,
              Events: ExportsEvents,
            }"
            :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')"
            v-on:format-columns="formatColumns"
            v-on:column-visibility-changed="gridComponentKey++"
          />
          <!-- END Grid -->
        </div>
      </div>
    </div>
    <loaderSpinner :loading="isLoading"></loaderSpinner>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import Configs from "../../configs";
import Swal from "sweetalert2";
import moment from "moment";
import MainService from "../services/MainService";
import progressBarRange from "../components/progressBarRange.vue";
import "@grapecity/wijmo.vue2.gauge";
import LoaderSpinner from "../components/LoadingSpinner.vue";
import * as wijmo from "@grapecity/wijmo";
import utils from "../Utils/libraries";
import { FlexGridFilter } from "@grapecity/wijmo.grid.filter";

import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";

import { ODataCollectionView } from "@grapecity/wijmo.odata";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import ToolTip from "@supervision/vue-components/components/Tooltip.vue";

import card from "@supervision/vue-components/components/Card.vue";

export default defineComponent({
  name: "CompaignDetail",
  components: {
    progressBarRange,
    LoaderSpinner,
    ContentTitle,
    OdataFlexGrid,
    ToolTip,
    card,
  },
  watch: {
      currentScope(newVal) {
        if (newVal) {
          this.mainService = new MainService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.mainService = new MainService(newVal, this.currentScope);
        }
      },
    culture() {
      this.gridComponentKey += 1;
    },
    StateCount: {
      handler() {
        this.componentKey += 1;
      },
      deep: true,
    },
  },
  data() {
    return {
      gridHeaders: {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': computed(() => this.isPreselectedScope ? this.preselectedScope : this.currentScopeView),
        'X-Custom-Filters': computed(() => this.headerFilters),
      },
      gridComponentKey: 1,
      mainService: new MainService(this.$jwt.token, this.$jwt.scope),
      currentScope: this.$jwt.scope,
      config: Configs,
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      culture: computed(() => this.$i18n.locale),
      compaign: {
        externalId: "",
        description: "",
        campaingEndDate: new Date(),
        firmwareversion: "55",
        manufacturerExternalId: "",
        statusEnum: "",
        downlinkChannelEnum: "",
        downlinkModulationEnum: "",
        createdDate: new Date(),
      },
      TooltipContent: "",
      TooltipContentProgressBar: "",
      equipmentID: null, // route param value
      isLoading: false,
      gauge: null,
      theGrid: null,
      latestDataState: null,
      filter: null,
      loading: true,
      rowsCount: 0,
      Globalfail: false,
      receivedData: null,
      compaignData: null,
      componentKey: 101,
      StateCount: {
        Successful: 0,
        InProgress: 0,
        Failed: 0,
        Pending: 0,
        Planned: 0,
      },

      // new grid

      FiltersDefinition: [
        {
          binding: "ExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "HardwareVersion",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "UpdatedDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "StatusEnum",
          hasValueFilter: true,
          hasConditionFilter: false,
        },
        {
          binding: "FailureErrorDetail",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
      ],
      ExportsHeader: { text: "Exports", icon: "scf-export" },
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      columns: [
        {
          binding: "ExternalId",
          width: "*",
          header: computed(() =>
            this.$t("pages.CompaignDetail.columns.ExternalId")
          ),
        },
        {
          binding: "UpdatedDate",
          width: "*",
          dataType: "Date",
          format: "MM/dd/yyyy",
          header: computed(() =>
            this.$t("pages.CompaignDetail.columns.UpdatedDate")
          ),
        },
        {
          binding: "HardwareVersion",
          width: "*",
          header: computed(() =>
            this.$t("pages.CompaignDetail.columns.HardwareVersion")
          ),
        },
        {
          binding: "StatusEnum",
          width: "*",
          header: computed(() =>
            this.$t("pages.CompaignDetail.columns.StatusEnum")
          ),
        },
        {
          binding: "FailureErrorDetail",
          width: "*",
          header: computed(() =>
            this.$t("pages.CompaignDetail.columns.FailureErrorDetail")
          ),
        },

        { header: "Actions", width: "*" },
      ],
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/OData/firmwareCampaignTransmitters/export?",
      // end grid
    };
  },
  methods: {
    gridFilterChanged(data) {
      this.latestDataState = data;
    },
    exportExcel() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel&firmwareCampaignId=${this.compaign.id}`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel&firmwareCampaignId=${this.compaign.id}`;
      }

      //  console.log(exportUrl);

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes("campaigndetail", type, "xlsx", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsv() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv&firmwareCampaignId=${this.compaign.id}`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv&firmwareCampaignId=${this.compaign.id}`;
      }

      console.log(exportUrl);

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes("campaigndetail", type, "csv", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onValueChanged: function (s) {
      this.theGauge.value = s.value;
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    valueChanged: function (s) {
      this.value = s.value;
    },
    gridInitialized(flexgrid) {
      this.theGrid = flexgrid;
      this.theGrid.loadingRows.addHandler(() => (this.loading = true));
      this.theGrid.loadedRows.addHandler(() => (this.loading = false));

      this.loadLayout();

      this.filter = new FlexGridFilter(this.theGrid);
    },

    ResetProgressBar() {
      this.StateCount.Pending = 0;
      this.StateCount.Successful = 0;
      this.StateCount.Failed = 0;
      this.StateCount.InProgress = 0;
      this.StateCount.Planned = 0;
    },
    updateStateProgressBar() {
      console.log(this.compaign);
      if (
        this.compaign.statusEnum == "Failed" ||
        this.compaign.statusEnum == "TechnicalFailure"
      ) {
        this.ResetProgressBar();
        this.Globalfail = true;
        this.StateCount.Pending = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Pending"
        ).length;
        this.StateCount.Successful = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Successful"
        ).length;
        this.StateCount.Failed = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Failed"
        ).length;
        this.StateCount.InProgress = this.receivedData.items.filter(
          (v) => v.StatusEnum == "InProgress"
        ).length;
        this.StateCount.Planned = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Planned"
        ).length;
      } else {
        this.StateCount.Pending = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Pending"
        ).length;
        this.StateCount.Successful = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Successful"
        ).length;
        this.StateCount.Failed = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Failed"
        ).length;
        this.StateCount.InProgress = this.receivedData.items.filter(
          (v) => v.StatusEnum == "InProgress"
        ).length;
        this.StateCount.Planned = this.receivedData.items.filter(
          (v) => v.StatusEnum == "Planned"
        ).length;
      }

      this.TooltipContentProgressBar =
        '<span class="tooltiptext1"><span class="title-tooltip1">' +
        this.$t("pages.CompaignDetail.Status") +
        '</span><br /><span class="badge rounded-pill bg-successful">' +
        this.StateCount.Successful +
        "</span>" +
        this.$t("pages.CompaignDetail.State.Successful") +
        '<br /><span class="badge rounded-pill bg-inProgress">' +
        this.StateCount.InProgress +
        "</span>" +
        this.$t("pages.CompaignDetail.State.InProgress") +
        '<br /><span class="badge rounded-pill bg-failed">' +
        this.StateCount.Failed +
        "</span>" +
        this.$t("pages.CompaignDetail.State.Failed") +
        '<br /><span class="badge rounded-pill bg-pending">' +
        this.StateCount.Pending +
        "</span>" +
        this.$t("pages.CompaignDetail.State.Pending") +
        '<br /><span class="badge rounded-pill bg-planned">' +
        this.StateCount.Planned +
        "</span>" +
        this.$t("pages.CompaignDetail.State.Planned") +
        "<br /></span>";
    },
    handlePageLoading() {
      this.loading = true;
    },
    handlePageLoaded() {
      this.loading = false;
      //  this.rowsCount = this.theGrid.rows.length;
    },

    formatColumns: function (s, e) {
      const flex = s;
      if (e.panel == flex.cells) {
        if (flex.rows[e.row].dataItem.name) return;
        if (flex.columns[e.col].header == "Actions") {
          e.cell.innerHTML =
            wijmo.format(
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:5px" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
              s.rows[e.row].dataItem
            ) +
            wijmo.format(
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:5px" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>',
              s.rows[e.row].dataItem
            ) +
            wijmo.format(
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:5px" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>',
              s.rows[e.row].dataItem
            );
        } else if (flex.columns[e.col].binding == "Description") {
          if (e.cell.textContent.trim().length > 20) {
            e.cell.innerHTML = wijmo.format(
              '<a href="#" action-type-description="showDescriptionInSwal">' +
                this.substringIfGreaterThanTweenty(e.cell.textContent.trim()) +
                "</a>",
              s.rows[e.row].dataItem
            );
          } else {
            e.cell.innerHTML = wijmo.format(e.cell.textContent.trim());
          }
        } else if (flex.columns[e.col].binding == "StatusEnum") {
          e.cell.innerHTML = wijmo.format(
            this.getTraductionState(e.cell.textContent.trim()),
            s.rows[e.row].dataItem
          );
        }
      }
    },

    getTraductionState: function (e) {
      return this.tryGetTranslation(`pages.CompaignDetail.State.${e}`);
    },
    getTraductionStateCompaign: function (e) {
      return this.tryGetTranslation(`pages.CompaignList.State.${e}`);
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
      ? this.$t(key)
      : key;
    },
    handleResize() {
      wijmo.Control.refreshAll();
    },
    saveLayout() {
      localStorage.setItem("compaign", this.theGrid.columnLayout);
    },
    loadLayout() {
      let layout = localStorage.getItem("compaign");
      if (layout) {
        this.columns = JSON.parse(layout).columns;
      }
    },
    showmessage() {
      Swal.fire("functionality not yet specified", "", "info");
    },
    showDescriptionInSwal(e) {
      Swal.fire("", e, "");
    },
    substringIfGreaterThanTweenty(e) {
      if (e.length > 20) {
        return e.substring(0, 17).concat("", "...");
      } else return e;
    },
    // new grid method

    //end grid method
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },

  async beforeMount() {},
  async mounted() {
    let externalId = this.$route.params.campaignId; //localStorage.getItem("campaign_externalId");

    let t = await this.mainService.getCompaignbyId(externalId);
    this.compaign = t[0];

    this.TooltipContent =
      "<span  ><span  >" +
      this.getTraductionStateCompaign(this.compaign.statusEnum) +
      ": </span><br />" +
      this.$t(
        "pages.CompaignList.StateDescription." + this.compaign.statusEnum
      ) +
      "</span>";

    this.receivedData = new ODataCollectionView(
      this.mainService.GetUriApi(),
      "FirmwareCampaignTransmitters?firmwareCampaignId=" + this.compaign.id,
      {
        fields: [
          "ExternalId",
          "HardwareVersion",
          "UpdatedDate",
          "StatusEnum",
          "FailureErrorDetail",
        ],
        pageOnServer: true,
        sortOnServer: true,
        filterOnServer: true,
      }
    );

    this.receivedData.loading.addHandler(() => this.handlePageLoading());
    this.receivedData.loaded.addHandler(
      () => (this.handlePageLoaded(), this.updateStateProgressBar())
    );
  },
});
</script>

<style scoped src="../assets/css/campaignDetail.css"></style>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
#about-page {
  font-family: "D-DIN" !important;
}
.ElementBox {
  font-family: D-DIN !important;
}
.title-Card {
  font-family: "D-DIN-900" !important;
}
.bg-successful {
  --bs-bg-opacity: 1;
  background-color: #6b8e23 !important;
}
.bg-inProgress {
  --bs-bg-opacity: 1;
  background-color: #8fce00 !important;
}
.bg-failed {
  --bs-bg-opacity: 1;
  background-color: #f44336 !important;
}
.bg-pending {
  --bs-bg-opacity: 1;
  background-color: #d3d3d3 !important;
}
.bg-planned {
  --bs-bg-opacity: 1;
  background-color: #3aa9e2 !important;
}

.tooltip1 {
  position: relative !important;
  //   display: inline-block!important;
  border-bottom: none !important;
  margin-left: 10px !important;
  font-family: D-DIN-PRO !important;
  opacity: 1 !important;
}

.btn {
  border: none !important;
}
.tooltip1 .tooltiptext1 {
  visibility: hidden !important;
  width: 250px !important;
  background-color: #030f40 !important;
  color: #ffffff !important;
  font-size: 16px;
  font-family: D-DIN !important;
  text-align: center !important;
  border-radius: 6px !important;
  padding: 5px 0 !important;
  position: absolute !important;
  z-index: 1 !important;
  bottom: 125% !important;
  left: 47% !important;
  margin-left: 0px !important;
  opacity: 0 !important;
  transition: opacity 0.3s !important;
  padding: 5px !important;
  text-align: justify !important;
}

.tooltip1 .tooltiptext1::after {
  content: "" !important;
  position: absolute !important;
  top: 100% !important;
  left: 0% !important;
  font-family: D-DIN !important;
  margin-left: -5px !important;
  border-width: 5px !important;
  border-style: solid !important;
  border-color: #555 transparent transparent transparent !important;
}

.tooltip1 .title-tooltip1 {
  text-transform: uppercase !important;
  color: #ffffff !important;
  text-decoration: underline !important;
  font-weight: bold !important;
}

.tooltip1:hover .tooltiptext1 {
  visibility: visible !important;
  opacity: 1 !important;
}

//draft
/* Tooltip container */
.tooltipx {
  position: relative;
  display: inline-block;
  opacity: 1;
  font-size: 1rem !important;
  /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltiptextx {
  visibility: hidden;
  height: auto;
  z-index: 1080 !important;
  background-color: #bbb;
  color: #f00;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  font-family: D-DIN !important;
  text-align: justify;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  white-space: nowrap;
  break-after: auto;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltipx:hover .tooltiptextx {
  visibility: visible;
  /*z-index: 1080 !important;*/
}

.tooltipx .title-tooltipx {
  text-transform: uppercase;
  color: yellow;
  text-decoration: underline;
  font-weight: 700;
  display: block;
}

.tooltip-top {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, -15px);
}

.tooltip-left {
  top: -7px;
  right: 100%;
}

.tooltip-bottom {
  top: 100%;
  left: 50%;
  transform: translate(-50%, 15px);
}

.tooltip-right {
  top: -7px;
  left: 100%;
  margin-left: 5px;
}
.tooltiptextx:before {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}
.tooltiptextx.tooltip-right:before {
  top: 15px;
  right: 100%;
  border-color: transparent #bbb transparent transparent;
}
.tooltiptextx.tooltip-top:before {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-color: #bbb transparent transparent transparent;
}
.tooltiptextx.tooltip-left:before {
  top: 15px;
  left: 100%;
  border-color: transparent transparent transparent #bbb;
}
.tooltip-bottom:before {
  bottom: 100%;
  left: 49%;
  border-color: transparent transparent #bbb transparent;
}
</style>

<style>
@import url("../../node_modules/@supervision/vue-components/fonts/fonts.css");
.card a {
  text-decoration: none !important;
  border: 0px !important;
}

.card .card-header .btn-actions-pane-right a.btn[data-v-4775b5a8] {
  padding: 2px !important;
  border: 0;
}
</style>
